import React, { forwardRef, useImperativeHandle } from 'react';
import { Selector, useLang } from '@manulife/mux';
import { Controller, useFormContext } from 'react-hook-form';
import LABELS from '../../../assets/labels';

const IrSmokingStatus = forwardRef(({ detailFor }, ref) => {
    const selectedLang = useLang();
    const { control } = useFormContext(); // retrieve all hook methods
    const name = `${detailFor}.irSmokingStatus`;
    const focusSmokingStatus = () => {
        // focus on first button of the smoking status      
        const element = document.getElementById(`${name}-0`);
        if (element) {
            element.focus();
        }
    };
    
    // Expose the focusSmokingStatus function via the ref
    useImperativeHandle(ref, () => ({
        focus: focusSmokingStatus
    }));

    return (
        <Controller
            control={control}
            name={name}
            rules={{
                required: LABELS.errors.required.irSmokingStatus[detailFor][selectedLang]
            }}
            render={({
                field: { onChange, onBlur, value, name },
                fieldState: { error },
            }) => (
                <Selector
                    id={name}
                    label={LABELS.question5[selectedLang][detailFor].question}
                    aria-label={LABELS.question5[selectedLang][detailFor].ariaLabel}
                    aria-required={true}
                    values={LABELS.question5[selectedLang].options}
                    selected={value}
                    onBlur={onBlur}
                    onChange={onChange}
                    errors={error && [error.message]}
                    callouts={false}
                    customStyle={{
                        rootStyle: {
                            width: "100%",
                        },
                    }}
                />
            )}
        />
    )
});

export default IrSmokingStatus;